import { Link } from 'react-router-dom';
import type { VideoItem } from '@/types/video';
import { detailPath } from '@/data/videos';

interface VideoCardProps {
  video: VideoItem;
  compact?: boolean;
}

export default function VideoCard({ video, compact = false }: VideoCardProps) {
  return (
    <Link
      to={detailPath(video)}
      className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-200 hover:border-accent-300"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-primary-900">
        <img
          src={video.cover}
          alt={`${video.title}封面`}
          title={`${video.title} - 高清影视在线观看`}
          className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/80 via-primary-950/5 to-transparent opacity-70 transition-opacity duration-300 group-hover:opacity-95" />

        <span className="absolute left-2 top-2 flex items-center gap-1 rounded-md bg-accent-500 px-1.5 py-0.5 font-label text-[11px] font-bold text-primary-950">
          <i className="ri-star-fill text-[10px]" />
          {video.rating.toFixed(1)}
        </span>

        {video.type === 'tv' && (
          <span className="absolute right-2 top-2 rounded-md bg-secondary-950/80 px-1.5 py-0.5 text-[11px] text-background-50">
            全{video.episodeCount}集
          </span>
        )}

        <span className="absolute inset-0 flex items-center justify-center">
          <span className="flex h-11 w-11 translate-y-2 items-center justify-center rounded-full bg-accent-500/95 text-primary-950 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
            <i className="ri-play-fill text-xl" />
          </span>
        </span>

        <div className="absolute inset-x-0 bottom-0 flex items-center gap-1.5 px-2.5 pb-2 text-[11px] text-background-100">
          <span>{video.regions[0]}</span>
          <span className="h-0.5 w-0.5 rounded-full bg-background-100/60" />
          <span className="truncate">{video.genres.slice(0, 2).join(' · ')}</span>
        </div>
      </div>

      <div className={compact ? 'px-2.5 py-2' : 'px-3 py-2.5'}>
        <h3 className="truncate text-[13px] font-medium text-foreground-950 transition-colors group-hover:text-primary-600 md:text-sm">
          {video.title}
        </h3>
        <p className="mt-1 truncate text-[11px] text-foreground-500 md:text-xs">
          {video.year} · {video.duration}
        </p>
      </div>
    </Link>
  );
}